import { SxProps, Theme, Typography } from '@mui/material';
import { useContext } from 'react';
import { FragmentGridContext } from '../../fragments-grid/FragmentGridContext';

/**
 * Shared title for fragment cards.
 * Uses body2 in compact grid mode so density stays on the theme scale.
 */
export function FragmentCardTitle({ title, sx }: { title: string; sx?: SxProps<Theme> }) {
  const isCompact = useContext(FragmentGridContext)?.viewMode === 'gridCompact';

  return (
    <Typography
      variant={isCompact ? 'body2' : 'subtitle1'}
      component="h3"
      title={title}
      sx={{
        lineHeight: 1.2, // Tighten from 1.75 to 1.2 for titles
        height: '2.4em', // Exact height for 2 lines (1.2 * 2)
        display: '-webkit-box',
        WebkitLineClamp: 2, // Limit to 2 lines
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...sx,
      }}
    >
      {title}
    </Typography>
  );
}
